import { render } from "./LogedInAvatarContext.vue?vue&type=template&id=185361cc&scoped=true"
import script from "./LogedInAvatarContext.vue?vue&type=script&lang=js"
export * from "./LogedInAvatarContext.vue?vue&type=script&lang=js"

import "./LogedInAvatarContext.vue?vue&type=style&index=0&id=185361cc&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185361cc"]])

export default __exports__